import { render, staticRenderFns } from "./DeliveryTest.vue?vue&type=template&id=1a84acb7&scoped=true&"
import script from "./DeliveryTest.vue?vue&type=script&lang=js&"
export * from "./DeliveryTest.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryTest.vue?vue&type=style&index=0&id=1a84acb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a84acb7",
  null
  
)

export default component.exports